import { BaseItem } from '@algolia/autocomplete-core';
import { Hit } from '@algolia/client-search';

export class Facet {
  static make({ name, label, operator }: { name: string; label?: string | boolean; operator?: string | null }): string {
    let facet = `${name}`;

    if (label != null) {
      facet = `${facet}:${typeof label === 'boolean' ? `${label}` : `'${label}'`}`;
    }

    if (operator) {
      facet = `${operator} ${facet}`;
    }

    return facet;
  }
}

export class FacetFilter {
  static make(parts: string[]): string {
    return parts.join(' AND ');
  }
}

/**
 * Exclusively bubble sort collection algolia results relative to the
 * rankInfo of the other results
 */
export function sortCollectionResults<TItem>(allItems: Hit<TItem>[]): Hit<TItem>[] {
  const isCollection = (hit: Hit<TItem>) => hit.hasOwnProperty('spaceType');
  const score = (hit: Hit<TItem>) => hit._rankingInfo?.userScore || 0;

  function bubbleSort(items: Hit<TItem>[]) {
    let swapped = true;

    while (swapped) {
      swapped = false;

      for (let i = 0; i < items.length - 1; i++) {
        const aIndex = i;
        const bIndex = i + 1;
        const aItem = items[aIndex];
        const bItem = items[bIndex];

        if (
          // only sort collections forward and back within the array
          (isCollection(aItem) && !isCollection(bItem) && score(aItem) < score(bItem)) ||
          (!isCollection(aItem) && isCollection(bItem) && score(aItem) < score(bItem))
        ) {
          // swap
          [items[bIndex], items[aIndex]] = [items[aIndex], items[bIndex]];
          swapped = true;
        }
      }
    }

    return items;
  }

  return bubbleSort(allItems);
}
